/**
 * Copyright (c) 2024 TechDivision GmbH
 * All rights reserved
 *
 * This product includes proprietary software developed at TechDivision GmbH, Germany
 * For more information see https://www.techdivision.com/
 *
 * To obtain a valid license for using this software please contact us at
 * license@techdivision.com
 *
 * @author Sebastian Hartmann <s.hartmann@techdivision.com>
 */
import React from 'react';
import './styles.scss';
import FmdGoodIcon from '@mui/icons-material/FmdGood';

/**
 * Marker Component
 * @returns {Element}
 * @constructor
 */
export function SearchMarker() {
  /**
     * Render the studio map marker
     * @returns {JSX.Element}
     */
  return (
    <FmdGoodIcon className="search-marker" sx={{ fontSize: 50 }} />
  );
}
